import { autobind } from 'core-decorators';
import React from 'react';

import { _ } from '/@/locale';

import classNames from 'classnames';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { resetProductComparison, setCatalogComparisons, setCatalogZone, setTechnology } from '/@/store/catalog/actions';
import { getCatalogComparisons, getCatalogZoneId, getSelectedTechnology } from '/@/store/catalog/selectors';

import ToggleGroup from '/@/v3/components/forms/toggle-group';
import Metrics from '/@/v3/components/metrics';

import styles from '../styles.module.css';
import brush from './assets/brush.svg?url';
import control from './assets/control.svg?url';
import plague from './assets/plague.svg?url';
import supress from './assets/supress.svg?url';
import uncontrol from './assets/uncontrol.svg?url';
import yields from './assets/yields.svg?url';

import seed from './assets/intacta-rr2-pro-seed.png';
import { useSoyTechnologies } from '/@/hooks/catalog';

@connect(
    (state, props) => {
        return {
            zone: getCatalogZoneId(state),
            selectedProductsForComparison: getCatalogComparisons(state),
        };
    },
    (dispatch) =>
        bindActionCreators(
            {
                setCatalogZone,
                setTechnology,
                setCatalogComparisons,
                resetProductComparison,
            },
            dispatch
        )
)
@autobind
class StaticSoyBiotechnology extends React.Component {
    // TO-DO: Manage state with Redux if needed, for now, using local state.
    state = {
        features: [],
        selectedZone: this.props.zones[0],
        selectedTechnology: this.props.technologies[0],
    };

    UNSAFE_componentWillMount() {
        if (!this.props.zone) this.props.setCatalogZone(this.props.zones?.[0]?.id);
        if (!this.props.selectedTechnology) this.props.setTechnology(this.props.technologies?.[0]?.id);
    }

    getZoneOptions() {
        return this.props.zones
            .filter((zone) => zone.crop === 'soy' && zone.countryId === this.props.country.id)
            .map((zone) => ({
                id: zone.id,
                label: _(zone.name),
                value: zone,
            }));
    }

    getTechOptions() {
        return this.props.technologies.map((tech) => ({
            id: tech.id,
            label: tech.name,
            value: tech,
        }));
    }

    handleChangeZone(zone) {
        this.setState((oldState) => ({
            ...oldState,
            selectedZone: zone,
        }));
    }

    handleChangeTech(tech) {
        this.setState((oldState) => ({
            ...oldState,
            selectedTechnology: tech,
        }));
    }

    handleChangeProducts(products) {
        this.setState((oldState) => ({
            ...oldState,
            features: products,
        }));
    }

    renderProperties() {
        return (
            <div className={styles.properties}>
                <div className={styles.title}>INTACTA RR2 PRO asegura</div>
                <div className={styles.container}>
                    <div className={styles.column}>
                        <div>
                            <img src={yields} />
                            {_('Más rendimiento')}
                        </div>
                        <p className={styles.content}>
                            {_(
                                'Conﬁere una mayor productividad en variedades de soja al contener la nueva generación de la tecnología Roundup Ready® (RR2Y). La misma fue obtenida utilizando los métodos más modernos de transformación de plantas y selección de eventos.'
                            )}
                            <br />
                            <br />
                            {_(
                                'En la campaña 2016/17, más de 10.000 productores vivieron la experiencia INTACTA RR2 PRO en sus campos. Y quienes sembraron ensayos/ desafíos con la tecnología INTACTA RR2 PRO comprobaron en un 85% de los casos, la diferencia de rendimiento con respecto a la tecnología RR1.'
                            )}
                            <br />
                            <br />
                            {_(
                                'INTACTA RR2 PRO demostró nuevamente un diferencial de rendimiento positivo, con un promedio del 6.4% de ventaja en las variedades INTACTA RR2 PRO sobre las RR1 a nivel país.'
                            )}
                        </p>
                    </div>

                    <div className={styles.column}>
                        <div>
                            <img src={brush} />
                            {_('Amplio control de malezas')}
                        </div>
                        <p className={styles.content}>
                            {_(
                                'Combina herramientas como rotación de cultivos, alternancia de modos de acción de los principios activos de los herbicidas, tamaño de las malezas y dosis óptima de aplicación. Su pilar fundamental es la planificación y el monitoreo continuo del lote para detectar los problemas a tiempo, bajar costos y maximizar los resultados para el productor.'
                            )}
                            <br />
                            <br />
                            {_(
                                'Hoy existen malezas resistentes a varios principios activos, incluyendo al glifosato. Con el objeto de prevenir o retrasar la aparición de estas resistencias y de manejar las existentes, Monsanto ha desarrollado el programa ROUNDUP READY PLUS, que cuenta con recomendaciones y asesoramiento técnico, y programas comerciales.'
                            )}
                        </p>
                    </div>
                    <div className={styles.column}>
                        <div>
                            <img src={plague} />
                            {_('Efectivo control de plagas')}
                        </div>
                        <p className={styles.content}>
                            {_(
                                'Menos aplicaciones y ahorro en los costos, gracias a un efectivo control de las principales orugas que atacan el cultivo.'
                            )}
                            <br />
                            <br />
                            {_(
                                'INTACTA RR2 PRO brinda un efectivo control de plagas lepidópteras a lo largo de todo el ciclo del cultivo gracias a la proteína BT. Esta protección permanente hace que su eficacia sea mucho mayor que la de cualquier insecticida.'
                            )}
                            <br />
                            <br />
                            {_(
                                'La tecnología INTACTA RR2 PRO permite un ahorro total de 1,5 aplicaciones promedio por hectárea, que implica menor consumo de agua, combustible y un menor uso de insecticidas. El control de lepidópteros elimina uno de los múltiples factores de estrés. La combinación de ambos beneficios (menor uso de insecticidas y menor cantidad de aplicaciones) representan en promedio un ahorro a nivel país de 20 a 25 USD por hectárea.'
                            )}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    renderInfo() {
        return (
            <div className={styles.info}>
                <div className={styles.description}>
                    <p>
                        <span>{_('INTACTA RR2 PRO ')}</span>
                        {_(
                            'es la biotecnología de Bayer, que otorga a las variedades de soja incremento en el rendimiento, reducción de costos de producción y simplicidad de manejo. Se lanzó en Argentina después de 18 años de la introducción de la soja'
                        )}
                        <span>{_(' RR1')}</span>
                        {_('. Más de 10.000 productores eligieron sembrar semilla de soja con tecnología')}
                        <span>{_(' INTACTA RR2 PRO')}</span>
                        {_(' la campaña pasada.')}
                        <br />
                        <br />
                        {_('El incremento del rinde de las distintas variedades de soja')}
                        <span>{_(' INTACTA RR2 PRO')}</span>
                        {_(
                            ' se produce gracias a la acción de la tecnología sobre el mejor germoplasma. A su vez, la selección y posicionamiento que realizan las compañías de semilla, son fundamentales para maximizar esos beneﬁcios. De este modo, se desarrolla un círculo virtuoso en el que, tanto biotecnología como el germoplasma, se complementan y se vuelven fundamentales para la maximización de resultados.'
                        )}
                        <br />
                        <br />
                        {_('Además, la tecnología')}
                        <span>{_(' INTACTA RR2 PRO')}</span>
                        {_(
                            ' es más amigable con el ambiente, porque permite utilizar menos insecticidas para mantener bajos los niveles de orugas.'
                        )}
                    </p>
                </div>
                <div className={styles.disclaimer}>
                    <p>
                        {_(
                            'INTACTA RR2 PRO es la tecnología en soja que ofrece a los productores uno de los mayores valores agregados'
                        )}
                        :<span>{_(' La tranquilidad de estar más protegidos.')}</span>
                    </p>
                    <div className={styles.seed}>
                        <img src={seed} />
                    </div>
                </div>
            </div>
        );
    }

    renderPlageControl() {
        return (
            <div className={styles.plagueControlContainer}>
                <div className={styles.plagueControl}>
                    <div className={styles.title}>{_('Control de plagas')}</div>
                    <p className={styles.subtitle}>{_('El control de plagas es el mismo en todas las variedades')}</p>

                    <div className={styles.plagues}>
                        <div>
                            <div className={styles.header}>
                                <img src={control} />
                                <span>{_('Controla')}</span>
                            </div>
                            <ul>
                                <li>
                                    <span>Anticarsia Gemmatalis</span> / Oruga de las leguminosas
                                </li>
                                <li>
                                    <span>Rachiplusia Nu </span>/ Oruga medidora
                                </li>
                                <li>
                                    <span>Helicoverpa gelotopoeon </span>/ oruga bolillera
                                </li>
                                <li>
                                    <span>Crocidosema aporema (ex epinotia) </span>/ barrenador del brote
                                </li>
                                <li>
                                    <span>Colias Lesbia </span>/ oruga de la alfalfa
                                </li>
                                <li>
                                    <span>Spilosoma virgínica </span>/ gata peluda
                                </li>
                                <li>
                                    <span>Loxostege bifidalis </span>/ Oruga de la verdolaga
                                </li>
                                <li>
                                    <span>Heliothis virescense </span>/oruga capullera
                                </li>
                                <li>
                                    <span>Chrysodieixis includens (ex Pseudoplusia) </span>/ Oruga falsa medidora
                                </li>
                            </ul>
                        </div>

                        <div>
                            <div className={styles.header}>
                                <img src={supress} />
                                <span>{_('Suprime')}</span>
                            </div>
                            <ul>
                                <li>
                                    <span>Helicoverpa zea </span>/ Isoca de la espiga
                                </li>
                                <li>
                                    <span>Spodoptera frugiperda </span>/ oruga militar tardía
                                </li>
                                <li>
                                    <span>Elasmopalpus lignosellus (Elasmopalpus)</span>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <div className={styles.header}>
                                <img src={uncontrol} />
                                <span>{_('No controla')}</span>
                            </div>
                            <ul>
                                <li>
                                    <span>Elasmopalpus lignosellus (Elasmopalpus)</span>
                                </li>
                                <li>
                                    <span>Spodoptera cosmioides </span>/oruga negra
                                </li>
                                <li>
                                    <span>Caliothrips phaseoli </span>/ Trips
                                </li>
                                <li>
                                    <span>Tetranichus urticae </span>/ Arañuelas
                                </li>
                                <li>
                                    <span>Sternechus subsignatus </span>/ picudo grande
                                </li>
                                <li>
                                    <span>Promecops sp </span>/ picudo chico de la soja
                                </li>
                                <li>
                                    <span>Rhyssomatus subtillis </span>/ picudo negro
                                </li>
                                <li>
                                    <span>Spodoptera eridiana </span>/ Eridiana
                                </li>
                                <li>
                                    <span>Agrotis ípsilon</span>
                                </li>
                                <li>
                                    <span>Agrotis maléfida</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderVarieties() {
        const { country, profiles, zones, setCatalogZone, setTechnology, technologies } = this.props;
        const profilesByBrand = profiles
            .reduce((acc, curr) => {
                const exist = acc.find((item) => item.name === curr.product.brand.name);

                if (exist) {
                    return acc.map((acumulator) => {
                        return {
                            ...acumulator,
                            items: [...acumulator.items, curr].filter((item) => {
                                return (
                                    item.product.brand.name === acumulator.name &&
                                    item.catalogZone === this.props.zone &&
                                    item.product.brand.countryId === this.props.country.id &&
                                    item.product.biotechnology.id === this.props.selectedTechnology.id
                                );
                            }),
                        };
                    });
                }

                return [
                    ...acc,
                    {
                        name: curr.product.brand.name,
                        items: [curr],
                    },
                ];
            }, [])
            .filter((product) => product.items.length);
        return (
            <div className={styles.varieties}>
                <div className={styles.title}>
                    {_('Variedades disponibles con INTACTA RR2 PRO')}
                    <hr />
                </div>
                <div className={styles.zoneSelector}>
                    <div className={styles.subtitle}>{_('Seleccioná una zona.')}</div>
                    <div className={styles.zones}>
                        {zones.map((zone) => {
                            return (
                                <div
                                    key={zone.id}
                                    onClick={() => setCatalogZone(zone.id)}
                                    className={classNames(this.props.zone === zone.id ? styles.selected : '')}
                                >
                                    {zone.name[country.language]}
                                </div>
                            );
                        })}
                    </div>

                    {technologies.length > 1 && (
                        <div>
                            <div className={styles.subtitle}>{_('Seleccioná una tecnologia.')}</div>
                            <div className={styles.technologies}>
                                {technologies.map((technology) => {
                                    const { selectedTechnology } = this.props;
                                    return (
                                        <div
                                            key={technology.id}
                                            onClick={() => setTechnology(technology.id)}
                                            className={classNames(
                                                selectedTechnology && selectedTechnology.id === technology.id
                                                    ? styles.selected
                                                    : ''
                                            )}
                                        >
                                            {technology.name}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    <div className={styles.brandCards}>
                        {profilesByBrand.map((profile) => {
                            return (
                                <div key={profile.id}>
                                    <div>{profile.name}</div>
                                    {profile.items.map((item) => (
                                        <span>{`${item.product.name}, `}</span>
                                    ))}
                                </div>
                            );
                        })}
                    </div>

                    <div className={styles.comparisonSelection}>
                        <div className={styles.subtitle}>{_('Compará hasta 4 variedades en simultáneo.')}</div>
                        <ToggleGroup
                            type='radio'
                            max={4}
                            value={this.props.selectedProductsForComparison}
                            options={this.buildOptions()}
                            onChange={this.props.setCatalogComparisons}
                        />
                        {this.props.selectedProductsForComparison.length > 0 && (
                            <div onClick={this.props.resetProductComparison} className={styles.delete}>
                                Borrar todo
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    buildOptions() {
        return this.props.profiles
            .filter((profile) => {
                return (
                    profile.product.biotechnology &&
                    this.props.selectedTechnology &&
                    profile.product.biotechnology.id === this.props.selectedTechnology.id &&
                    profile.catalogZone === this.props.zone
                );
            })
            .map((profile) => ({ value: profile.productId, label: profile.product.name }));
    }

    renderComparison() {
        const { selectedProductsForComparison, brand } = this.props;
        const features = this.buildFeatures();

        if (selectedProductsForComparison.length === 0) return null;
        return (
            <div className={styles.comparison}>
                <div className={styles.subtitle}>{_('Características')}</div>
                <hr />
                <Metrics title={_('Características')} dataKey='features' products={features} brand={this.props.brand} />
            </div>
        );
    }

    buildFeatures() {
        const { selectedProductsForComparison, profiles, zone } = this.props;
        return profiles.filter(
            (profile) =>
                selectedProductsForComparison.includes(profile.productId) && profile.catalogZone === this.props.zone
        );
    }

    render() {
        return (
            <div>
                {this.renderInfo()}
                {this.renderProperties()}
                {this.renderPlageControl()}
                {this.renderVarieties()}
                {this.renderComparison()}
            </div>
        );
    }
}

const StaticSoyBiotechnologyWrapper = (props) => {
    const soyTechnologiesQuery = useSoyTechnologies({ page: 1, pageSize: 10000 });
    const selectedTechnology = useSelector((state) => getSelectedTechnology(state, soyTechnologiesQuery.data?.results));

    return <StaticSoyBiotechnology {...props} selectedTechnology={selectedTechnology} />;
};

export default StaticSoyBiotechnologyWrapper;
